module.exports = __webpack_public_path__ + "static/media/PHP-logo.f5e22029.svg";